export const CLASS_NAMES = {
  container: 'flex w-full overflow-hidden',
  steps: 'mt-18 ml-10 lg:ml-20 lg:absolute',
  title:
    'absolute top-12 left-30 lg:left-38 text-style-f-em text-netural-800 border-l border-neutral-300 ml-6 pl-6',
};

export const TITLE = 'Finance application';

export const PROPS = {
  content: {
    flex: true,
    left: true,
    width: 'w-100 max-w-100',
  },
};
